import React from "react";
import articleimg from "../assets/images/newageislam-dummy.jpg";
import { GetUrlLink, formatDateTime, checkImageExists } from "../utility";
const searchResults = ({ data }) => {
  if (!data.length) {
    return <h2 className="noFound mt-3 text-center"> No results found</h2>;
  }
  return data.map(
    ({
      Article_ID,
      Group_Name,
      Article_Heading,
      AutherName,
      Article_Detail,
      ImageName,
      CreatedDateTime,
      Comments,
      Comments_ID,
      Name,
    }) => {
      let parsedADetail = Comments
        ? Comments.replace(/<[^>]+>/g, "")
        : Article_Detail.replace(/<[^>]+>/g, "");
      let ADetail =
        parsedADetail.length > 450
          ? parsedADetail.substring(0, 450) + ".."
          : parsedADetail;
      return (
        <div
          key={Comments_ID ? Comments_ID : Article_ID}
          className="debatingIslamWrap"
        >
          <div className="media position-relative debatingIslamBox border-bottom pb-2 mb-2">
            {ImageName &&
            ImageName !== "NAI_NewAgeIslam.jpg" &&
            ImageName !== "NAI_NewAgeIslam.png" ? (
              checkImageExists(ImageName, AutherName)
            ) : (
              <img
                src={articleimg}
                className="img-fluid"
                alt={AutherName}
                width="90"
                height="75"
              />
            )}
            <div className="media-body px-3 py-2">
              <h2 className="mb-1">{Group_Name}</h2>
              <h3 className="mb-1">
                {AutherName ? (
                  <a
                    rel="noopener noreferrer"
                    target="_blank"
                    href={`/${GetUrlLink(Group_Name)}/${GetUrlLink(
                      AutherName
                    )}/${GetUrlLink(Article_Heading)}/d/${Article_ID}`}
                    className="d-block"
                  >
                    {Article_Heading}
                  </a>
                ) : (
                  <a
                    rel="noopener noreferrer"
                    target="_blank"
                    href={`/${GetUrlLink(Group_Name)}/${GetUrlLink(
                      Article_Heading
                    )}/d/${Article_ID}`}
                    className="d-block"
                  >
                    {Article_Heading}
                  </a>
                )}
              </h3>
              <small className="font-italic d-block mb-1 font-weight-bold">
                {AutherName}
              </small>
              {CreatedDateTime ? (
                <b className="mb-1">
                  Posted : {formatDateTime(CreatedDateTime)}
                </b>
              ) : null}
              <p
                dangerouslySetInnerHTML={{
                  __html: ADetail,
                }}
              ></p>
              {Name ? <b className="mb-1">Posted By : {Name} </b> : null}
              <p>
                <b>URL</b>:
                {AutherName
                  ? `${window.location.origin}/${GetUrlLink(
                      Group_Name
                    )}/${GetUrlLink(AutherName)}/${GetUrlLink(
                      Article_Heading
                    )}/d/${Article_ID}`
                  : `${window.location.origin}/${GetUrlLink(
                      Group_Name
                    )}/${GetUrlLink(Article_Heading)}/d/${Article_ID}`}
              </p>
              {AutherName ? (
                <a
                  rel="noopener noreferrer"
                  target="_blank"
                  href={`/${GetUrlLink(Group_Name)}/${GetUrlLink(
                    AutherName
                  )}/${GetUrlLink(Article_Heading)}/d/${Article_ID}`}
                  className="stretched-link1 d-block"
                >
                  Read More <i className="fa fa-angle-double-right"></i>
                </a>
              ) : (
                <a
                  rel="noopener noreferrer"
                  target="_blank"
                  href={`/${GetUrlLink(Group_Name)}/${GetUrlLink(
                    Article_Heading
                  )}/d/${Article_ID}`}
                  className="stretched-link1 d-block"
                >
                  Read More <i className="fa fa-angle-double-right"></i>
                </a>
              )}
            </div>
          </div>
        </div>
      );
    }
  );
};
export default searchResults;
